import { Validators } from "@angular/forms";
import { leiFormatValidator } from "../../validators/lei-format.validator";

export const ISSUERS_ENTITY = [
  {
    key: 'entityName',
    displayValue: 'Entity Name',
    validators: [Validators.required]
  },
  {
    key: 'lei',
    displayValue: 'LEI',
    validators: [leiFormatValidator(), Validators.required],
  },
  {
    key: 'fitchRating',
    displayValue: 'Fitch Rating',
  },
  {
    key: 'moodysRating',
    displayValue: "Moody's Rating",
  },
  {
    key: 'spRating',
    displayValue: 'S&P Rating',
  },
  {
    key: 'workflowStatus',
    displayValue: 'Workflow Status',
    hideOnForm: true
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  },
  {
    key: 'deletedAt',
    displayValue: 'Deleted On',
    hideOnForm: true
  }
];
